import {AddIcon, Button, ButtonIcon, ButtonText, FormGroup} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import {type FC, memo, useCallback, useEffect} from "react";
import {useController, useFormContext, useWatch} from "react-hook-form";

import useHandleArrayField from "../useHandleArrayField";

import FeeForm from "./FeeForm";
import FeeList from "./FeeList";

const Fees: FC = () => {
    const {control, trigger} = useFormContext<Listing>();
    const {
        fields: fees,
        obj: fee,
        isOpen,
        onOpen,
        onEdit,
        onRemove,
        onSave,
        onCancel
    } = useHandleArrayField("fees");
    const {
        formState: {errors}
    } = useController({
        control,
        name: "fees",
        rules: {
            validate: useCallback(() => {
                if (isOpen) {
                    return "Please save or close form to continue";
                }
                return true;
            }, [isOpen])
        }
    });

    const currency = useWatch({control, name: "currency"});

    useEffect(() => {
        if (!isOpen) {
            trigger("fees");
        }
    }, [trigger, isOpen]);

    return (
        <FormGroup isInsideTab error={errors?.fees?.root?.message} label="Fees" name="fees.root">
            {!isOpen && (
                <Button className="self-end" variant="ghost" onPress={onOpen}>
                    <ButtonIcon as={AddIcon} />
                    <ButtonText>Fee</ButtonText>
                </Button>
            )}
            {(fees ?? []).length > 0 && (
                <FeeList
                    currency={currency ?? ""}
                    fees={fees}
                    onEdit={onEdit}
                    onRemove={onRemove}
                />
            )}
            {isOpen && (
                <FeeForm currency={currency ?? ""} fee={fee} onCancel={onCancel} onSave={onSave} />
            )}
        </FormGroup>
    );
};

export default memo(Fees);
